import React from "react";
import InfoImg from "../../images/SideBar/Info";

interface InfoTableProps {
  data: { [key: string]: string | number };
  title: string;
}

const InfoTable: React.FC<InfoTableProps> = ({ data, title }) => {
  return (
    <>
    <thead>
        <tr>
          <th className=" text-fontBlack font-semibold text-sm p-2  flex gap-1 ">
            <p className="">
              <InfoImg />
            </p>
            <p className="mt-[0.7%] ml-1">{title}</p>
          </th>
        </tr>
      </thead>
        <table className="rounded border-opacity-60 bg-white w-full">
      <tbody className="">
        {Object.entries(data).map(([key, value]) => (
          <tr key={key} className="">
            
            <td className="mb-2 font-medium text-fontBlack text-sm border p-[0.5%] w-1/3 pl-2 bg-tableBg">
              {key}
            </td>
            <td className="text-fontBlack text-sm font-normal  border pl-2">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </>
  );
};

export default InfoTable;
